/**
 * Helpers para persistência e redirecionamento de posts do blog.
 */

import { doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { getFirestore } from 'firebase/firestore';

const BLOG_POST_UI_FIELDS = new Set(['newCategory']);

/** Remove campos de UI antes de gravar no Firestore. */
export function sanitizeBlogPostForFirestore(postData) {
  if (!postData || typeof postData !== 'object') return postData;
  const cleaned = { ...postData };
  BLOG_POST_UI_FIELDS.forEach((key) => delete cleaned[key]);
  return cleaned;
}

/**
 * Registra redirecionamento 301 quando o slug muda.
 * Coleção: blogRedirects/{oldSlug}
 */
export async function saveBlogSlugRedirect({ oldSlug, newSlug, postId }) {
  if (!oldSlug || !newSlug || oldSlug === newSlug || !postId) return;
  const db = getFirestore();
  await setDoc(
    doc(db, 'blogRedirects', oldSlug),
    {
      oldSlug,
      newSlug,
      postId,
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );
}
